import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { TextField, Select, MenuItem, Box } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { Save, ChevronLeft, Plus, Trash2, Pencil } from "lucide-react";

import TextfieldInput from "../../Shared/TextField";
import TitlePage from "../../Shared/TitlePage";
import { dataService } from "../../../Services/data/data.service";
import { externalApiTypes, externalApiEnumBehaviorTypes } from "../../../Config/constants";
import "react-toastify/dist/ReactToastify.css";

// Components
import TableList from "../ModifyExternalApi/Components/ModifyExternalApiList";
import DescriptionItem from "../../Shared/DescriptionItem";

function CreateExternalApiPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const GetUserId = props.Login.userid;
  const [connectionName, setConnectionName] = useState("");
  const [connectionDesc, setConnectionDesc] = useState("");
  const [errorConnectionName, setErrorConnectionName] = useState(false);
  const [errorCompany, setErrorCompany] = useState(false);
  const [htConnectionName, setHtConnectionName] = useState("");
  const [emptyDetails, setEmptyDetails] = useState(false);
  const [apiBodyItems, setApiBodyItems] = useState([]);

  const [allExternalApiTypes, setAllExternalApiTypes] = useState([]);
  const [allUserCompanies, setAllUserCompanies] = useState([]);

  const [company, setCompany] = useState(null);
  const [helperTextCompany] = useState("");

  const [externalApiType, setExternalApiType] = useState(null);
  const [helperTextExternalApiType, setHelperTextExternalApiType] = useState("");
  const [errorExternalApiType, setErrorExternalApiType] = useState("");

  // Enum options state
  const [enumOptions, setEnumOptions] = useState([]);
  const [newEnumValue, setNewEnumValue] = useState("");
  const [newEnumDescription, setNewEnumDescription] = useState("");
  const [editingEnumId, setEditingEnumId] = useState(null);
  const [editEnumValue, setEditEnumValue] = useState("");
  const [editEnumDescription, setEditEnumDescription] = useState("");
  const [enumError, setEnumError] = useState(false);

  // Enum behavior type state (Anchor / Sticky)
  const [enumBehaviorTypeId, setEnumBehaviorTypeId] = useState(null);

  useEffect(() => {
    dataService.getAllCompaniesByUserId(props.Login.userid).then((results) => {
      setAllUserCompanies(results);
    });

    dataService.getAllExternalApiTypes().then((results) => {
      setAllExternalApiTypes(results);
      setExternalApiType(results[0]);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (externalApiType) {
      if (externalApiType.id === externalApiTypes.STOPWATCH) {
        setStopwatchRows();
      } else if (externalApiType.id === externalApiTypes.DATA) {
        setDataRows();
      } else if (externalApiType.id === externalApiTypes.NUMERIC) {
        setCountRows();
      } else if (externalApiType.id === externalApiTypes.ENUM) {
        setEnumRows();
      }
    }
  }, [externalApiType]);

  const setConnectionNameState = (event) => {
    setConnectionName(event.target.value);
  };

  const setConnectionDescState = (event) => {
    setConnectionDesc(event.target.value);
  };

  const setStopwatchRows = () => {
    let tempStopwatchItems = [
      {
        Id: 1,
        itemName: "stopwatchReference",
        itemDescription: "Reference to stop a earlier started stopwatch",
      },
      {
        Id: 2,
        itemName: "startTime",
        itemDescription: "The time the stopwatch starts",
      },
      {
        Id: 3,
        itemName: "stopTime",
        itemDescription: "The time the stopwatch stops",
      },
      {
        Id: 4,
        itemName: "keyValue",
        itemDescription: "Optional key value (can be used to link an api measurement to an order)",
      },
      {
        Id: 5,
        itemName: "singleTimer",
        itemDescription: "When true, starting a new timer will stop other running timers on this API",
      },
    ];

    setApiBodyItems(tempStopwatchItems);
  };

  const setDataRows = () => {
    let tempDataItems = [
      {
        Id: 1,
        itemName: "keyValue",
        itemDescription: "Optional key value (can be used to link an api measurement to an order)",
      },
      {
        Id: 2,
        itemName: "measurementTime",
        itemDescription: "The time the measurement is taken (e.g. dd:mm:yyyy hh:mm:ss 15/05/2025 14:30:00)",
      },
      {
        Id: 3,
        itemName: "customReference",
        itemDescription: "Optional custom reference to update measurements later",
      },
    ];

    setApiBodyItems(tempDataItems);
  };

  const setCountRows = () => {
    let tempCountItems = [
      {
        Id: 1,
        itemName: "keyValue",
        itemDescription: "Optional key value (can be used to link an api measurement to an order)",
      },
      {
        Id: 2,
        itemName: "value",
        itemDescription: "The amount you want to pass (e.g. 5 or -3)",
      },
      {
        Id: 3,
        itemName: "measurementTime",
        itemDescription: "The time the measurement is taken (e.g. dd:mm:yyyy hh:mm:ss 15/05/2025 14:30:00)",
      },
      {
        Id: 4,
        itemName: "customReference",
        itemDescription: "Optional custom reference to update measurements later",
      },
    ];

    setApiBodyItems(tempCountItems);
  };

  const setEnumRows = () => {
    let tempEnumItems = [
      {
        Id: 1,
        itemName: "value",
        itemDescription: "The enum option value to submit (must match one of the defined options)",
      },
      {
        Id: 2,
        itemName: "keyValue",
        itemDescription: "Optional key value (can be used to link an api measurement to an order)",
      },
      {
        Id: 3,
        itemName: "measurementTime",
        itemDescription: "The time the measurement is taken (e.g. dd:mm:yyyy hh:mm:ss 15/05/2025 14:30:00)",
      },
      {
        Id: 4,
        itemName: "customReference",
        itemDescription: "Optional custom reference to update measurements later",
      },
    ];

    setApiBodyItems(tempEnumItems);
    setEnumOptions([]);
    setEnumBehaviorTypeId(null);
  };

  const setRows = (event) => {
    setApiBodyItems(event);
  };

  const clearApiRows = () => {
    setApiBodyItems([]);
  };

  const validate = () => {
    var validationOK = true;
    if (connectionName === "") {
      validationOK = false;
      setHtConnectionName("Please enter a connection name");
      setErrorConnectionName(true);
    } else {
      setHtConnectionName("");
      setErrorConnectionName(false);
    }

    if (company === null || company === "") {
      validationOK = false;
      setErrorCompany(true);
    }

    if (!externalApiType || externalApiType === "") {
      validationOK = false;
      setHelperTextExternalApiType("Please select an API type");
      setErrorExternalApiType(true);
    } else {
      setHelperTextExternalApiType("");
      setErrorExternalApiType(false);
    }

    if (apiBodyItems.length === 0 || apiBodyItems[0].itemName === "") {
      validationOK = false;
      setEmptyDetails(true);
    } else {
      setEmptyDetails(false);
    }

    if (externalApiType && externalApiType.id === externalApiTypes.ENUM && enumOptions.length === 0) {
      validationOK = false;
      setEnumError(true);
    } else {
      setEnumError(false);
    }

    return validationOK;
  };

  const sendToApi = () => {
    if (validate()) {
      var items = JSON.stringify(apiBodyItems.map((item) => ({ Name: item.itemName, Description: item.itemDescription })));
      dataService.createNewApi(connectionName, connectionDesc, externalApiType.id, company.id, items, GetUserId, externalApiType.id === externalApiTypes.ENUM ? enumBehaviorTypeId : null).then((results) => {
        if (externalApiType.id === externalApiTypes.ENUM && enumOptions.length > 0) {
          // Save all enum options for the newly created API
          const savePromises = enumOptions.map((option) =>
            dataService.createEnumOption(results.id, option.value, option.description, GetUserId)
          );
          Promise.all(savePromises).then(() => {
            navigate(`/modifyapi/${results.uniqueId}`);
          });
        } else {
          navigate(`/modifyapi/${results.uniqueId}`);
        }
      });
    }
  };



  // Enum option handlers
  const addEnumOption = () => {
    if (newEnumValue.trim() === "") return;
    const newOption = {
      id: Date.now(),
      value: newEnumValue.trim(),
      description: newEnumDescription.trim(),
    };
    setEnumOptions([...enumOptions, newOption]);
    setNewEnumValue("");
    setNewEnumDescription("");
    setEnumError(false);
  };

  const removeEnumOption = (id) => {
    setEnumOptions(enumOptions.filter((o) => o.id !== id));
  };

  const startEditEnumOption = (option) => {
    setEditingEnumId(option.id);
    setEditEnumValue(option.value);
    setEditEnumDescription(option.description);
  };

  const saveEditEnumOption = () => {
    if (editEnumValue.trim() === "") return;
    setEnumOptions(
      enumOptions.map((o) =>
        o.id === editingEnumId ? { ...o, value: editEnumValue.trim(), description: editEnumDescription.trim() } : o
      )
    );
    setEditingEnumId(null);
    setEditEnumValue("");
    setEditEnumDescription("");
  };

  return (
    <React.Fragment>
      <TitlePage Text="Create a new API" backbutton={true} {...props} />
      <Box
        sx={{
          maxWidth: "90%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginRight: "auto",
          marginLeft: "auto",
          marginTop: "120px",
        }}
      >
        <div className={classes.header}>
          <button className={classes.backButton} onClick={() => navigate("/externalapioverview")}>
            <ChevronLeft className={classes.backButton__icon} />
            Back to API overview
          </button>
          <h1>Create a new API</h1>
        </div>
        <div className={classes.container}>
          <div className={classes.formContainer}>
            <div className={classes.formColumn}>
              <div className={classes.projectOption}>
                <div className={classes.projectOption__labelContainer}>
                  {htConnectionName === "" ? <label className={classes.labelContainer__label}>API name</label> : <label className={classes.labelContainer__helperText}>{htConnectionName}</label>}
                </div>
                <TextfieldInput label={connectionName ? " " : "API"} InputLabelProps={{ shrink: false }} value={connectionName} action={setConnectionNameState} error={errorConnectionName} />
              </div>
              <div className={classes.projectOption}>
                <div className={classes.projectOption__labelContainer}>
                  {helperTextCompany === "" ? (
                    <label className={classes.labelContainer__label}>Select a company</label>
                  ) : (
                    <label className={classes.labelContainer__helperText}>{helperTextCompany}</label>
                  )}
                </div>
                <Select
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  displayEmpty
                  error={errorCompany}
                  helperText={helperTextCompany}
                  style={{ width: "100%" }}
                  renderValue={company !== "" ? undefined : () => "Company"}
                >
                  {/* If no company is selected, this is a placeholder */}
                  {allUserCompanies.length < 1 && (
                    <MenuItem value="">
                      <em>You are not part of a company</em>
                    </MenuItem>
                  )}
                  {/* Populate the dropdown with companies from allUserCompanies */}
                  {allUserCompanies.map((company, index) => (
                    <MenuItem key={index} value={company}>
                      {company.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className={classes.projectOption}>
                <div className={classes.projectOption__labelContainer}>
                  {helperTextExternalApiType === "" ? (
                    <label className={classes.labelContainer__label}>Select an API-type</label>
                  ) : (
                    <label className={classes.labelContainer__helperText}>{helperTextExternalApiType}</label>
                  )}
                </div>
                <Select
                  value={externalApiType}
                  onChange={(e) => setExternalApiType(e.target.value)}
                  displayEmpty
                  error={errorExternalApiType}
                  helperText={helperTextExternalApiType}
                  style={{ width: "100%" }}
                  renderValue={externalApiType !== "" ? undefined : () => "API-type"}
                >
                  {/* If no company is selected, this is a placeholder */}
                  {allExternalApiTypes.length < 1 && (
                    <MenuItem value="">
                      <em>There are no types to choose from</em>
                    </MenuItem>
                  )}
                  {/* Populate the dropdown with companies from allUserCompanies */}
                  {allExternalApiTypes
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((apiType, index) => (
                      <MenuItem key={index} value={apiType}>
                        {apiType.name}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            </div>
            <div className={classes.listDescriptionStyle}>
              <div className={classes.projectOption__labelContainer}>
                <p className={classes.labelContainer__label}>Description of your API</p>
              </div>
              <textarea className={classes.description__textarea} value={connectionDesc} onChange={(e) => setConnectionDescState(e)}></textarea>
              {/* <TextfieldInput label={connectionDesc ? " " : "Description"} InputLabelProps={{ shrink: false }} rows={3} multiline value={connectionDesc} action={setConnectionDescState} /> */}
            </div>
          </div>
          {emptyDetails === true ? (
            <div style={{ marginTop: "2rem" }}>
              <DescriptionItem Text="Add data pointss" />
              <TableList {...props} rows={apiBodyItems} setRows={setRows} apiTypeId={externalApiType && externalApiType.id} makeSave={sendToApi} />
              <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>Please create at least one data point.</p>
            </div>
          ) : (
            <div style={{ marginTop: "2rem" }}>
              <DescriptionItem Text="Add data points" />
              <TableList {...props} rows={apiBodyItems} setRows={setRows} apiTypeId={externalApiType && externalApiType.id} />
            </div>
          )}
          {externalApiType && externalApiType.id === externalApiTypes.ENUM && (
            <div style={{ marginTop: "2rem" }}>
              <DescriptionItem Text="Enum behavior type" />
              <div style={{ display: "flex", gap: "8px", marginBottom: "1rem" }}>
                <Select
                  value={enumBehaviorTypeId || ""}
                  onChange={(e) => setEnumBehaviorTypeId(e.target.value || null)}
                  displayEmpty
                  style={{ minWidth: "220px" }}
                  renderValue={(selected) => {
                    if (!selected) return "Standard (no behavior)";
                    if (selected === externalApiEnumBehaviorTypes.ANCHOR) return "Anchor";
                    if (selected === externalApiEnumBehaviorTypes.STICKY) return "Sticky";
                    return "Standard (no behavior)";
                  }}
                >
                  <MenuItem value="">Standard (no behavior)</MenuItem>
                  <MenuItem value={externalApiEnumBehaviorTypes.ANCHOR}>Anchor</MenuItem>
                  <MenuItem value={externalApiEnumBehaviorTypes.STICKY}>Sticky</MenuItem>
                </Select>
              </div>
              <DescriptionItem Text="Define enum options" />
              <div className={classes.enumContainer}>
                <div className={classes.enumInputRow}>
                  <TextField
                    label="Option value"
                    variant="outlined"
                    value={newEnumValue}
                    onChange={(e) => setNewEnumValue(e.target.value)}
                    style={{ flex: 1, minWidth: "150px" }}
                    onKeyDown={(e) => { if (e.key === "Enter") addEnumOption(); }}
                  />
                  <TextField
                    label="Description (optional)"
                    variant="outlined"
                    value={newEnumDescription}
                    onChange={(e) => setNewEnumDescription(e.target.value)}
                    style={{ flex: 2, minWidth: "200px" }}
                    onKeyDown={(e) => { if (e.key === "Enter") addEnumOption(); }}
                  />
                  <button className={classes.primaryIconButton} onClick={addEnumOption} disabled={!newEnumValue.trim()}>
                    <Plus className={classes.iconButton__icon} absoluteStrokeWidth />
                    Add
                  </button>
                </div>
                {enumOptions.length > 0 && (
                  <div className={classes.enumList}>
                    {enumOptions.map((option) => (
                      <div key={option.id} className={classes.enumItem}>
                        {editingEnumId === option.id ? (
                          <>
                            <TextField
                              variant="outlined"
                              size="small"
                              value={editEnumValue}
                              onChange={(e) => setEditEnumValue(e.target.value)}
                              style={{ flex: 1, minWidth: "120px" }}
                              onKeyDown={(e) => { if (e.key === "Enter") saveEditEnumOption(); }}
                            />
                            <TextField
                              variant="outlined"
                              size="small"
                              value={editEnumDescription}
                              onChange={(e) => setEditEnumDescription(e.target.value)}
                              style={{ flex: 2, minWidth: "180px" }}
                              onKeyDown={(e) => { if (e.key === "Enter") saveEditEnumOption(); }}
                            />
                            <button className={classes.enumActionButton} onClick={saveEditEnumOption}>
                              <Save size={16} />
                            </button>
                          </>
                        ) : (
                          <>
                            <span className={classes.enumValue}>{option.value}</span>
                            <span className={classes.enumDescription}>{option.description}</span>
                            <button className={classes.enumActionButton} onClick={() => startEditEnumOption(option)}>
                              <Pencil size={16} />
                            </button>
                            <button className={classes.enumActionButtonDelete} onClick={() => removeEnumOption(option.id)}>
                              <Trash2 size={16} />
                            </button>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {enumError && (
                  <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em", marginTop: "4px" }}>
                    Please add at least one enum option.
                  </p>
                )}
              </div>
            </div>
          )}
          <div className={classes.buttonContainer}>
            <button className={classes.primaryIconButton} onClick={sendToApi}>
              <Save className={classes.iconButton__icon} absoluteStrokeWidth />
              Save
            </button>{" "}
          </div>
        </div>
      </Box>
    </React.Fragment>
  );
}

export default CreateExternalApiPage;
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "1.5rem",
    maxWidth: "100%",
    marginBottom: "3rem"
  },

  header: {
    width: "100%",
    height: "40px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    marginBottom: "16px",
  },

  backButton: {
    position: "absolute",
    top: "95px",

    display: "flex",
    alignItems: "center",
    gap: "4px",

    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "#0C0E29",
    opacity: ".8",

    border: "none",
    padding: "0px",

    transition: "opacity ease-in-out .1s",

    "&:hover": {
      opacity: "1",
      cursor: "pointer",
    },
  },

  backButton__icon: {
    height: "16px",
    width: "16px",

    strokeWidth: "1.4px",
  },

  buttonContainer: {
    marginTop: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },

  primaryIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "#C3996B",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  disabledIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "#DCDCDC",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    "&:hover": {
      cursor: "not-allowed",
    },
  },

  iconButton__icon: {
    height: "20px",
    width: "20px",

    display: "block",
  },

  formContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: "16px",

    marginBottom: "16px",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "8px",
    },
  },

  formColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  projectOption: {
    minWidth: "240px",
    maxWidth: "100%",

    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },

  labelContainer__label: {
    fontSize: "16px",
    color: "rgb(105, 105, 105)",
    margin: "0",
  },

  labelContainer__helperText: {
    fontSize: "16px",
    color: "#D84949",
    margin: "0",
  },

  listDescriptionStyle: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    position: "relative",
  },

  description__textarea: {
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    padding: "8px",
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    backgroundColor: "transparent",
    border: "1px solid #BDBDBD",
    borderRadius: "4px",
    resize: "none",

    [theme.breakpoints.down("sm")]: {
      height: "120px",
    },
  },

  generateApiKeyContainer: {
    display: "flex",
    gap: "8px",
    flexDirection: "row",
    alignItems: "center",

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  generateAPIbutton: {
    height: "40px",
    padding: "0 16px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "#C3996B",

    transition: "all 0.2s ease-in-out",
    whiteSpace: "nowrap",

    userSelect: "none",

    "&:hover": {
      backgroundColor: "#a77d4f",
      cursor: "pointer",
    },
  },

  copyAPIbutton: {
    background: "#C3996B !important",
    color: "white",
    height: "56px",
    borderBottomLeftRadius: "0px !important",
    borderTopLeftRadius: "0px !important",
    border: "1px solid #C3996B !important",
    transition: "0.3s",
    "&:hover": {
      background: "rgba(195, 153, 107, 0.75) !important",
    },
    "&:disabled": {
      background: "rgba(0, 0, 0, 0.12) !important",
      color: "rgba(0, 0, 0, 0.26) !important",
      border: "rgba(0, 0, 0, 0.26) 1px solid!important",
    },
  },

  ApiContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    border: "1px solid #989898",
    borderRadius: "4px",

    padding: "8px",
  },

  ApiFormatContainer: {
    height: "fit-content",

    display: "flex",
    flexDirection: "column",

    border: "1px solid #989898",
    borderRadius: "4px",

    padding: "8px",
  },

  ApiFormatContainer__buttonContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  tertiaryButton: {
    height: "40px",
    padding: "0 16px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "rgba(12, 14, 41, 0.6)",
    backgroundColor: "transparent",

    transition: "all 0.2s ease-in-out",
    whiteSpace: "nowrap",

    userSelect: "none",

    "&:hover": {
      color: "rgba(12, 14, 41)",
      backgroundColor: "#EDEDED",
      cursor: "pointer",
    },
  },

  apiTextField: {
    height: "40px",
    width: "100%",

    fontSize: "16px",

    backgroundColor: "transparent",
    border: "none",
  },

  generateApiKeyButton: {
    backgroundColor: "#C3996B",
    color: "white",
    width: "220px",
    borderRadius: "4px",
    border: "none",
    outline: "none",
    cursor: "pointer",
    marginRight: "5px",
    height: "55px",
    fontSize: "15px",
  },

  enumContainer: {
    border: "1px solid #989898",
    borderRadius: "4px",
    padding: "16px",
  },

  enumInputRow: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    flexWrap: "wrap",
  },

  enumList: {
    marginTop: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  enumItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    border: "1px solid #e0e0e0",
  },

  enumValue: {
    flex: 1,
    fontWeight: "600",
    fontSize: "14px",
    color: "#0C0E29",
    minWidth: "120px",
  },

  enumDescription: {
    flex: 2,
    fontSize: "14px",
    color: "#696969",
    minWidth: "180px",
  },

  enumActionButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "transparent",
    color: "#0B4097",
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },

  enumActionButtonDelete: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "transparent",
    color: "#d32f2f",
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: "#fce4e4",
    },
  },
}));
